import { ITypeOption } from "@/components/excel/schema/definiens/bizType";
import {
  HourSelector,
  MinuteSelector,
  SecondSelector,
} from "@/components/excel/schema/selector/date-time";
import {
  HourMinuteMode,
  HourMinuteSecondMode,
  HourMode,
  MinuteMode,
  MinuteSecondMode,
  SecondMode,
} from "@/components/excel/schema/value/mode/time";
import { YearOption } from "@/components/excel/schema/value/type/date";
const base = 400;
export const HourOption: ITypeOption = {
  value: base + 1,
  text: "时",
  mode: HourMode,
  selector: HourSelector,
};
export const MinuteOption: ITypeOption = {
  value: base + 2,
  text: "分",
  mode: MinuteMode,
  selector: MinuteSelector,
  parent: HourOption,
};
HourOption.child = MinuteOption;
export const SecondOption: ITypeOption = {
  value: base + 3,
  text: "秒",
  mode: SecondMode,
  selector: SecondSelector,
  parent: MinuteOption,
};
MinuteOption.child = SecondOption;
export const HourMinuteOption: ITypeOption = {
  value: base + 4,
  text: "时-分",
  mode: HourMinuteMode,
  child: SecondOption,
};
export const MinuteSecondOption: ITypeOption = {
  value: base + 5,
  text: "分-秒",
  mode: MinuteSecondMode,
  parent: YearOption,
};
export const HourMinuteSecondOption: ITypeOption = {
  value: base + 6,
  text: "时-分-秒",
  mode: HourMinuteSecondMode,
};
